<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="1" align="center">
                 <v-avatar color="indigo">
                    <img v-if="hasImage"
                    :src="getUserImage"
                    >
                    <span v-else>{{getUserName.substring(0,1)}}</span>
                </v-avatar>
                <v-card-title class="justify-center">{{getUserName}}</v-card-title>
            </v-col>
            <v-col cols="12" md="11">
                <v-card-text>{{localMessage.content}}</v-card-text>
                <v-card-subtitle>{{getDate}}</v-card-subtitle>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data () {
        return {
            localUsers: [],
            localMessage: {}
        }
    },
    props: {
        message: Object,
        users: Array
    },
    mounted(){
        if (this.message){
            this.localMessage = this.message;
        }
    },
    computed: {
        getUserName(){
            //Check if its a notification/server message
            if (this.localMessage.uid === null) {
                return "TeethCase: "
            }
            const user = this.localUsers.find(user => user.uid === this.localMessage.uid);
            if (!user) {
                //If this user doesn't exist 
                return "User not found";
            }
            return user.displayname;
        },
        getUserImage(){
            //Check if its a notification/server message
            if (this.localMessage.uid === null) {
                return "A bot/image of our logo"
            }
            
            const user = this.localUsers.find(user => user.uid === this.localMessage.uid);
            if (!user) {
                //If this user doesn't exist
                return "Some not found image url"
            }
            return user.photo;
        },
        hasImage(){
            //Check if its a notification/server message
            if (this.localMessage.uid === null) {
                return false
            }

            const user = this.localUsers.find(user => user.uid === this.localMessage.uid);
            if (!user) {
                //If this user doesn't exist
                return false;
            }
            // Eventually we will add a check in here to see if the url is valid
            if (user.photo === "") {
                //If this user doesn't exist 
                return false
            }
            return true;
        },
        getDate(){
            var messageDate = moment(this.localMessage.date);
            var now = moment();

            return messageDate.from(now);
        }
    },
    watch: {
        users: { 
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                if (val !== null){
                    this.localUsers = val;
                }
            }
        }
    }
}
</script>